
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useEffect, useState } from "react";
import useFetchApi from "../../hooks/useFetchApi";

function CalenderBookingFront() {

    const localizer = momentLocalizer(moment);



    // const { data, loading, error } = useFetchApi({
    //     // url: 'https://orisoftpl.com/backend/api/admin/dashboard',
    //     url: 'https://orisoftpl.com/backend/api/frontend/calendar',
    //     dataKey: 'recentBookings',
    //     authType: 'user'// ✅ auth token
    // });

    const { data, loading, error } = useFetchApi({
        url: "https://orisoftpl.com/backend/api/frontend/calendar",
        dataKey: "events",
    });

    const events = data.map((item) => ({
        title: item.title,
        allDay: item.allDay,
        start: new Date(item.start),
        end: new Date(item.end),
    }));

    console.log("events:-", events);
    console.log("calender Data:", data);

    if (loading) return <p>Loading...</p>;
    if (error) return <p>{error}</p>;
    return (
        <>
            <div className="bg-white rounded shadow-lg mt-5">
                <h4 className="text-lg p-4 font-semibold border-b">Booking Calender</h4>
                <div className="p-4 h-[800px]">
                    {/* <Calendar
                        localizer={localizer}
                        events={events}
                        startAccessor="start"
                        endAccessor="end"
                        // 👇 ADD IT HERE
                        eventPropGetter={(event) => {
                            let bg = "#6b7280";

                            if (event.title.includes("Approved")) bg = "#22c55e";
                            if (event.title.includes("Pending")) bg = "#ef4444";
                            if (event.title.includes("Rejected")) bg = "#ef4444";

                            return {
                                style: {
                                    backgroundColor: bg,
                                    color: "white",
                                },
                            };
                        }}
                        style={{ height: "100%" }}
                    /> */}
                    <Calendar
                        localizer={localizer}
                        events={events}
                        startAccessor="start"
                        endAccessor="end"
                        eventPropGetter={(event) => {
                            const isApproved = event.title.includes("Approved");

                            return {
                                style: {
                                    backgroundColor: isApproved
                                        ? "#22c55e"
                                        : "#ef4444",
                                    color: "white",
                                },
                            };
                        }}
                        style={{ height: "100%" }}
                    />
                </div>
            </div>
        </>
    )
}

export default CalenderBookingFront